export const EXTENSION_URLS = {
  chrome: 'https://chromewebstore.google.com/detail/jobtrackr.it/fiagbbcopemiiihbndfbgnamckghikdg',
  firefox: 'https://addons.mozilla.org/en-US/firefox/addon/jobtrackr-it/',
  edge: 'https://microsoftedge.microsoft.com/addons/detail/jobtrackrit/fnhmlnjlimnikmadhlhebjnfkjcoohck',
} as const
